export default __webpack_public_path__ + "static/media/shield.87c4aeef.png";